// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';
import { getAuth } from "firebase/auth"; // Import the auth module


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCRNsQBca1ERVlxCZ_AdAFGk8K6AVZY89Q",
  authDomain: "stcaths-sacramental-program.firebaseapp.com",
  projectId: "stcaths-sacramental-program",
  storageBucket: "stcaths-sacramental-program.appspot.com",
  messagingSenderId: "414940732090",
  appId: "1:414940732090:web:cc032ef000b7676e948083",
  measurementId: "G-61DPYD82FJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app); // Initialize Firestore
export const storage = getStorage(app); // Initialize Storage
export const auth = getAuth(app); // Initialize Authentication


// If you need analytics, you can initialize it as well
// const analytics = getAnalytics(app);
